// utils/fetchAudio.js
export const fetchAudio = async (text) => {
    const apiKey = 'sk_0e2d2aabca5dcc196824c46c9ec494acba481369f1d082c4'
// 'sk_28878d2ea8627733762355743d2db329602d80083068cfe9';
    const voiceId = 'pwMBn0SsmN1220Aorv15'
    // 'JBFqnCBsd6RMkjVDRZzb'; // Replace with your desired voice ID
  
    const response = await fetch(`https://api.elevenlabs.io/v1/text-to-speech/${voiceId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'xi-api-key': apiKey,
      },
      body: JSON.stringify({
        text,
        model_id: 'eleven_multilingual_v2',
        output_format: 'mp3_44100_128',
        
      }),
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch audio from ElevenLabs API');
    }
  
    const audioBlob = await response.blob();
    return URL.createObjectURL(audioBlob);
  };
  